export interface VacationsRouter {
  goToDetail(id: string): void;
  goToList(query?: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VacationsRouter = Symbol('VacationsRouter');
